import { equipmentTemplates } from "../data/templates";

export const getEquipmentImageByModel = (model) => {
  if (model === null) {
    return null;
  }

  const normalizedModel = model.replaceAll(" ", "").toLowerCase();

  for (const family of Object.values(equipmentTemplates)) {
    const equipment = family.find(item => {
      if (!item.model) return false;
      const normalizedItemModel = item.model.replaceAll(" ", "").toLowerCase();
      return normalizedModel === normalizedItemModel;
    });
    if (equipment) {
      return equipment.image;
    }

    const equipment2 = family.find(item => {
      if (!item.model) return false;
      const normalizedItemModel = item.model.replaceAll(" ", "").toLowerCase();
      return normalizedModel.startsWith(normalizedItemModel);
    });
    if (equipment2) {
      return equipment2.image;
    }
  }
  return null;
};